import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DynamicImageDirective } from '../../directives/dynamic-images/dynamic-image.directive';
import { IMAGES_RESOLUTIONS } from '../../utils/image-config';

@Component({
  selector: 'app-image',
  standalone: true,
  imports: [CommonModule, DynamicImageDirective],
  templateUrl: './image.component.html',
  styleUrl: './image.component.scss'
})
export class ImageComponent {

	@Input() src: string;
	@Input() alt: string;
	@Input() placeholder: string = '/src/assets/images/undefined-image.png';
	@Input() width: string = '100%';
	@Input() height: string = 'auto';
	@Input() fitCover: boolean = false;
	@Input() customClass: string = '';
	@Input() borderRadius: string = '0';
	@Input() imageResolutions: number[] = [IMAGES_RESOLUTIONS.md, IMAGES_RESOLUTIONS.sm];

	constructor(){}

	imageNullOrEmpty(): string {
		return this.src ? this.src : this.placeholder;
	}

}
